import { useTranslation } from "react-i18next";
import LegalPage from "@/components/LegalPage";
import { Button } from "@/components/ui/button";
import { useCookiePrefs } from "@/components/CookiePrefsContext";

export default function CookiePolicy() {
  const { t } = useTranslation();
  const { openManager } = useCookiePrefs();
  const keys = ["what", "gcm", "categories", "vendors", "control", "legal"];
  return (
    <LegalPage
      title={t("pages.cookies.title")}
      updated={t("pages.cookies.updated")}
      intro={t("pages.cookies.intro")}
      sectionKeys={keys}
      i18nRoot="pages.cookies.sections"
      testIdRoot="cookies"
      footer={
        <Button
          type="button"
          onClick={openManager}
          className="h-11 rounded-lg tracking-[0.06em]"
          data-testid="cookies-open-manager"
        >
          {t("pages.cookies.open_manager")}
        </Button>
      }
    />
  );
}
